angular
    .module('editingCenterWeiBoModule')
    .service('weiboApiService', [
        'trsHttpService',
        '$q',
        function(trsHttpService, $q) {
            let commonParams = {
                serviceid: 'wcm61_scmmicrocontent',
                dataSource: 'wcm',
            };

            return {
                trail: requestData, // 送审
                getList: requestData, // 获取微博列表
                findFgdById: requestData, // 根据微博ID获取发稿单
                getHomeTimeLine: requestData, // 获取主页时间线上的微博数据
                delete: requestData, // 删除微博（从石榴云平台删除）
                restore: requestData, // 还原微博
                clearTrash: requestData, // 清空废稿箱
                getShortURL: requestData, // 获取微博视频短链接
                getMetionMe: getMetionMe, // 获取提到我的微博 或者 提到我的评论
                getMyWeibo: requestData, // 获取我的微博（按照时间线）
                destroy: requestData, // 从微博平台删除微博
                isLock: requestData, // 判断微博是否上锁
                lock: requestData, // 微博上锁
                unLock: requestData, // 微博解锁
                forceUnLock: requestData, // 微博强制解锁
                trialByPropagandaDepartment: requestData, // 宣传部送审
                getDetail: requestData, // 微博渠道获取微博内容
                save: requestData, // 保存微博
                directSign: requestData, // 直接签发
                repost: requestData, // 转发微博
                timeSign: requestData, // 定时签发微博
                withDraw: requestData, // 微博撤稿
                cancelSign: requestData, // 取消签发 
                shareToOhterTanant: requestData, // 租户间共享
                calculateWords: calculateWords, // 计算微博字数
            };

            /**
             * [dealParams 公共的参数适配方法]
             *
             * @param   {[type]}  params  [params description]
             *
             * @return  {[type]}          [return description]
             */
            function dealParams(params) {
                return params;
            }

            /**
             * [getMetionMe 获取@我的微博何评论]
             *
             * @param   {[type]}  params  [params description]
             *
             * @return  {[type]}          [return description]
             */
            function getMetionMe(params) {
                let meTionMeParams = dealMetionParams(params);
                return requestData(meTionMeParams);
            }

            /**
             * [dealMetionParams 处理提到我的评论的服务参数]
             *
             * @param   {[type]}  params  [params description]
             *
             * @return  {[type]}          [return description]
             */
            function dealMetionParams(params){
                if (params.methodname === 'queryCommentMentionsToJson') {
                    params.serviceid = 'wcm61_scmcomment';
                }
                return params;
            }

            /**
             * [dealData 适配响应数据]
             *
             * @param   {[type]}  data  [data description]
             *
             * @return  {[type]}        [return description]
             */
            function dealData(data) {
                return data;
            }

            /**
             * [requestData 统一的请求方法，默认请求方法]
             *
             * @param   {[type]}  params  [params description]
             * @param   {[type]}  noAlart  [params description]
             *
             * @return  {[type]}          [return description]
             */
            function requestData(params, noAlart) {
                let deffer = $q.defer();
                let requestParams = angular.extend({}, commonParams, dealParams(params));
                let dataSource = requestParams.dataSource ? requestParams.dataSource : 'bigData';
                let httpMethod = requestParams.httpMethod ? requestParams.httpMethod : 'post';
                if (requestParams.dataSource) {
                    delete requestParams.dataSource;
                }
                if (requestParams.httpMethod) {
                    delete requestParams.httpMethod;
                }
                let url = getRequestUrl(dataSource);
                trsHttpService.httpServer(url, requestParams, httpMethod, noAlart).then(
                    function(data) {
                        let result = dealData(data);
                        deffer.resolve(result);
                    },
                    function(data) {
                        deffer.reject(data);
                    }
                );
                return deffer.promise;
            }

            /**
             * [getRequestUrl 获取请求URL]
             *
             * @param   {[type]}  type  [type description]
             *
             * @return  {[type]}        [return description]
             */
            function getRequestUrl(type){
                let urlMap = {
                    'wcm': trsHttpService.getWCMRootUrl(), 
                    'bigData': trsHttpService.getBigDataRootUrl(), 
                    'wb': trsHttpService.getWeiboRootUrl(),
                };
                return urlMap[type];
            }

            /**
             * [trim description] 格式化字符串
             * @param   {[string]}  str    [str description] 输入的字符串
             * @return  {[string]}         [return description] 格式化后的字符串
             */
            function trimStr(str){
                try {
                    return str.replace(/^\s+|\s+$/g, '');
                } catch (error) {
                    return str;
                }
            }

            /**
             * [byteLength description] 获得字节长度
             * @param   {[string]}  str   [str description] 输入的字符
             * @return  {[number]}        [return description] 计算的长度
             */
            function getByteLength(str){
                if (typeof str === 'undefined') {
                    return 0;
                }
                var calculateStr = str.match(/[^\x00-\x80]/g);
                return (str.length + (!calculateStr ? 0 : calculateStr.length));
            }

            /**
             * [calculateWords description] 计算微博字数（此部分从按照微博代码获得）
             * @param   {[string]}  str     [str description] 输入的内容
             * @param   {[object]}  option  [option description] 配置项
             * @return  {[number]}          [return description]
             */
            function calculateWords(str, option){
                option = option || {};
                option.max = option.max || 140;
                option.min = option.min || 41;
                option.surl = option.surl || 20;
                var p = trimStr(str).length;
                if (p > 0) {
                    var j = option.min,
                        s = option.max,
                        b = option.surl,
                        n = str;
                    var r = str.match(/(http|https):\/\/[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+([-A-Z0-9a-z\$\.\+\!\_\*\(\)\/\,\:;@&=\?~#%]*)*/gi) || [];
                    var h = 0;
                    for (var m = 0,
                        p = r.length; m < p; m++) {
                        var o = getByteLength(r[m]);
                        if (/^(http:\/\/t.cn)/.test(r[m])) {
                            continue;
                        } else {
                            if (/^(http:\/\/)+(weibo.com|weibo.cn)/.test(r[m])) {
                                h += o <= j ? o : (o <= s ? b : (o - s + b));
                            } else {
                                h += o <= s ? b : (o - s + b);
                            }
                        }
                        n = n.replace(r[m], '');
                    }
                    return Math.ceil((h + getByteLength(n)) / 2);
                } else {
                    return 0;
                }
            }
        },
    ])
    .value('weiboApiParams', {
        // 送审参数
        trailParams: {
            methodname: 'processToTrialToJson',
            ObjectIds: '',
        },
        // 融合稿件列表参数
        listParams: {
            methodname: 'QueryByResultSetToJson',
            FlowStatus: '',
            AccountId: '',
            PageIndex: '',
            PageSize: '',
            StartTime: '',
            EndTime: '',
        },
        // 获取发稿单信息参数
        findFgdInfoParams: {
            methodname: 'findFgdByMicroContentIdToJson',
            MicroContentId: '',
        },
        // 主页时间线微博列表参数
        homeTimeLineParams: {
            methodname: 'queryHomeTimelineToJson',
            PageIndex: '',
            PageSize: '',
            AccountId: '',
        },
        // 删除微博的参数
        deleteParams: {
            methodname: 'deleteMicroContentToJson',
            MicroContentIds: '',
            AccountId: ''
        },
        // 稿件还原参数
        restoreParams: {
            methodName: 'restoreMicroContent',
            AccountId: '',
            MicroContentId: '',
            option: '',
        },
        // 清空废稿箱参数
        clearTrashParams: {
            methodName: 'clearRecycle',
            AccountId: ''
        },
        // 获取视频短链接参数
        shortURLParams: {
            methodname: 'getShortURL',
            URL: '',
            httpMethod: 'get'
        },
        // 获取提到我的微博参数
        metionMeParams: {
            methodname: 'queryMentionsToJson',
            PageIndex: '',
            PageSize: '',
            AccountId: '',
        },
        // 获取提到我的评论参数
        metionMeCommentParams: {
            methodname: 'queryCommentMentionsToJson',
            PageIndex: '',
            PageSize: '',
            AccountId: '',
        },
        // 获取我的微博时间线参数
        myWeiboParams: {
            methodname: 'queryUserTimelineToJson',
            PageIndex: '',
            PageSize: '',
            AccountId: '',
        },
        // 从微博平台删除微博的参数
        destroyParams: {
            methodname: 'destroyMicroContentToJson',
            MicroContentId: '',
            AccountId: '',
        },
        // 判断微博是否上锁的参数
        isLockParams: {
            methodname: 'checkLockToJson',
            ObjectId: '',
        },
        // 微博上锁的参数
        lockParams: {
            methodname: 'lockDocToJson',
            ObjectId: '',
        },
        // 微博解锁参数
        unLockParams: {
            methodname: 'unLockToJson',
            ObjectId: '',
        },
        // 微博强制解锁餐宿
        forceUnLockParams: {
            methodname: 'forcedUnLockToJson',
            ObjectId: '',
        },
        // 宣传部送审参数
        trialByPropagandaDepartmentParams: {
            methodname: 'trialByPropagandaDepartment',
            ObjectIds: '',
            opinion: '',

        },
        // 微博渠道获取微博参数
        detailParams: {
            methodname: 'findByIdToJson',
            ObjectId: '',
            httpMethod: 'get',
        },
        // 保存微博的参数
        saveParams: {
            methodname: 'saveMicroBlogToJson',
            AccountIds: '',
            Content: '',
            DOCGENRE: '',
            FGD_AUTHINFO: '[]',
            FGD_EDITINFO: '[]',
            ISNOPAYMENT: 1,
            ObjectId: 0,
            Picture: '',
            SCMGroupId: 1,
            Source: '',
            isContainSensitiveWords: 0,
        },
        directSignParams: {
            methodname: 'processToPubOfDaiBianToJson',
            content: '',
            ObjectIds: '',
            dataSource: 'wb',
        },
        rePostParams: {
            methodname: 'forwardMicroContentToJson',
            AccountIds: '',
            Content: '',
            SCMGroupId: 1,
            modulename: '',
            ScheduleTime: '',
            DocGenre: '',
            IsNoPayment: 1,
            fgd_editinfo: '',
            fgd_authinfo: '',
            isContainSensitiveWords: '0',
            dataSource: 'wb'
        },
        // 定时签发参数
        timeSignParams: {
            methodname: 'publishTaskOfDaiBianToJson',
            AccountIds: '',
            ObjectIds: 0,
            ScheduleTime: '',
            dataSource: 'wb'
        },
        // 撤稿参数
        withDrawParams: {
            methodname: 'processToReworkToJson',
            content: '',
            ObjectIds: '',
            dataSource: 'wb'
        },
        // 取消签发参数
        cancelSignParams: {
            methodname: 'rwMicroContent',
            MicroContentId: '',
            AccountId: '',
            option: '',
        },
        shareToOhterTanantParams: {
            methodname: 'pluralisticShare',
            ObjectId: '',
        }
    });
